import {Component, Inject, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from '@angular/material/card';
import {
  MX_TRANSLATE_SERVICE_TOKEN,
  MxButtonModel,
  MxButtonModule,
  MxDynamicFieldsModule,
  MxSharedModule,
  MxTranslateService
} from 'mx-core';
import {PrlLanguageModule} from '../../../prl-language/prl-language.module';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PrlProfilesService} from '../../../../shared/services/prl-profiles.service';
import {PrlAccountDataService} from '../../../prl-dashboard/services/account/prl-account-data.service';

@Component({
  selector: 'prl-add-profile-dialog',
  imports: [
    FormsModule,
    MatCard,
    MatCardContent,
    MatCardHeader,
    MatCardTitle,
    MxButtonModule,
    MxDynamicFieldsModule,
    MxSharedModule,
    PrlLanguageModule,
    ReactiveFormsModule
  ],
  templateUrl: './prl-add-profile-dialog-component.html',
  styleUrl: './prl-add-profile-dialog-component.scss',
})
export class PrlAddProfileDialogComponent implements OnInit {
  @Input()
  campaignId: string;
  form: FormGroup;

  protected requestInProcess = false;
  protected addButton: MxButtonModel;
  protected cancelButton: MxButtonModel;

  private userId = 0;
  constructor(
      private readonly accountDataService: PrlAccountDataService,
      private readonly dialogRef: MatDialogRef<PrlAddProfileDialogComponent>,
      private readonly fb: FormBuilder,
      private readonly profilesService: PrlProfilesService,
      @Inject(MX_TRANSLATE_SERVICE_TOKEN) private readonly translateService: MxTranslateService,
      @Inject(MAT_DIALOG_DATA) public data: {
        campaignId: string
      }
  ) {
    this.campaignId = data.campaignId;

    this.form = this.fb.group({
      profileName: ['', [Validators.maxLength(100), Validators.minLength(1)]],
    });
  }

  ngOnInit(): void {
    this.addButton = {
      label: () => this.translateService.getTranslatedLabel('label.submit'),
      tooltip: () => this.translateService.getTranslatedLabel('label.submit'),
      className: 'mxs-button--primary',
      disabled: this.requestInProcess,
      clickHandler: () => this.addProfile()
    };
    this.cancelButton = {
      label: () => this.translateService.getTranslatedLabel('label.cancel'),
      tooltip: () => this.translateService.getTranslatedLabel('label.cancel'),
      className: 'mxs-button--secondary',
      disabled: this.requestInProcess,
      clickHandler: () => this.dialogRef.close(false)
    };
    this.accountDataService.getCurrentAccount().subscribe(account => {
      this.userId = account.id;
    });
  };

  private addProfile = () => {
    this.requestInProcess = true;
    const profileName = (this.form.controls['profileName'].value as string).trim();
    if (profileName === '') {
      this.dialogRef.close(false);
    }
    const newProfile = {
      name: profileName,
      campaignId: this.campaignId,
      userId: +this.userId,
    };
    this.profilesService.createProfile(newProfile)
        .subscribe(
            {
              next: () => {
                this.dialogRef.close(true);
                this.requestInProcess = false;
              },
              error: (_) => {
                this.dialogRef.close(false);
                this.requestInProcess = false;
              }
            });
  };
}
